import { PropsWithChildren, forwardRef, memo } from 'react';
import { useCurrentEditor } from '@tiptap/react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import useIsEditorEditable from './hooks/useIsEditorEditable';

const EditorContainer = forwardRef<HTMLDivElement, PropsWithChildren<{ className?: string }>>(
  function EditorContainer({ children, className }, ref) {
    const { editor } = useCurrentEditor();
    const isEditable = useIsEditorEditable();

    if (!editor) return null;

    return (
      <div
        ref={ref}
        className={twMerge(
          cn(
            'box-border relative leading-normal border rounded-md border-solid resize-none border-neutral-200 ring-primary-400',
            {
              'focus-within:ring-2': isEditable,
            },
            className,
          ),
        )}
      >
        {children}
      </div>
    );
  },
);

export default memo(EditorContainer);
